import { Module, VuexModule, Mutation, getModule } from 'vuex-module-decorators'
import { store } from '@/store'
import { UserInfo } from '@/models/session/user'

@Module({ name: 'Auth', dynamic: true, store })
class SessionModule extends VuexModule {
  accessToken = ''
  refreshToken = ''
  user: UserInfo = {
    username: null,
    avatar: null,
    role: null
  }

  @Mutation
  public updateAccessToken(token: string) {
    this.accessToken = token
  }

  @Mutation
  public updateRefreshToken(token: string) {
    this.refreshToken = token
  }

  @Mutation
  public cleanAccessToken() {
    this.accessToken = ''
  }

  @Mutation
  public cleanRefreshToken() {
    this.refreshToken = ''
  }

  @Mutation
  public updateUserInfo(user: UserInfo) {
    this.user = user
  }

  @Mutation
  public cleanUserInfo() {
    this.user = {
      username: null,
      avatar: null,
      role: null
    }
  }
}

export const sessionStore = getModule(SessionModule)
